import { mapDeviceSearchResult } from 'apis/SearchDevices';
import { createDevice } from 'common/utils/helpers';
import { getTimeRange } from 'components/shared/TimeSelect';

export function toActionsPayload({ from, to, span, devices, actions, runtimeStatuses }) {
  if (span) {
    const timeRange = getTimeRange({ span });
    from = timeRange[0];
    to = timeRange[1];
  }
  return {
    devices,
    events: actions,
    runtimeStatuses,
    from,
    to
  };
}

export function fromActionsResult({ actionInstances = [] }) {
  return actionInstances;
}

export function fromDeviceResult({ devices }) {
  return createDevice(devices);
}

export function fromSearchDevicesResult(data) {
  return mapDeviceSearchResult(data);
}
